<template>
  <section class="back-to-shop">
    <button type="button"
            ref="backButton"
            class="btn button-back-to-shop"
            :title="$t('confirmation.linkBack')"
            @click="supportButtonBackClick">
      {{ returnText }}
    </button>
    <p v-if="showTimer">{{ $t('confirmation.linkBackTimeout') }} {{redirectTime}} {{ $t('confirmation.linkBackTimeoutTime') }}</p>
    <input type="hidden" style="margin: 10px;" id="iframefocus" value="">
  </section>
</template>

<script>
import { ToolsClass } from '@/base/class/tools.class'
import { MobileAppClass } from '@/base/class/mobileApp.class'
import Vue from 'vue'
import { CONFIRMATION_REDIRECT_TIME } from '@/base/const/confirmation.const'
import {
  MATOMO_EVENT_CATEGORY,
  MATOMO_EVENT_TYPE
} from '@/base/const/matomo.const'
import { MatomoClass } from '@/base/class/matomo.class'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'PartnerReturnBtn',
  data () {
    return {
      redirectHandler: null,
      redirectTime: Vue.prototype.$VUE_CONFIRMATION_TIMER ? Vue.prototype.$VUE_CONFIRMATION_TIMER : CONFIRMATION_REDIRECT_TIME
    }
  },
  props: {
    returnText: {
      type: String,
      required: true
    },
    returnUrl: {
      type: String,
      required: true
    },
    showTimer: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    isCommercialBreakClosed: function (val) {
      console.log('isCommercialBreakClosed', val)
      if (val) {
        this.goBackToShop()
      }
    }
  },
  computed: {
    ...mapState({
      isCommercialBreakClosed: state => state.ads.commercialBreakClosed
    }),
    ...mapGetters({
      isCommercialBreakDataSet: 'isCommercialBreakDataSet'
    })
  },
  methods: {
    ...mapMutations([
      'SET_ADS_SHOW_COMMERCIAL_BREAKE'
    ]),
    supportButtonBackClick () {
      this.sendEventButtonClickToMatomo()
      this.goBackToShop()
    },
    goBackToShop () {
      this.stopRedirectTimeout()
      if (this.isCommercialBreakDataSet && !this.isCommercialBreakClosed) {
        this.SET_ADS_SHOW_COMMERCIAL_BREAKE(true)
        return
      }
      if (ToolsClass.isMobileAppConnection()) {
        MobileAppClass.callMobileTransactionFinish()
        return
      }
      ToolsClass.goToExternalUrl(this.returnUrl)
    },
    stopRedirectTimeout () {
      if (this.redirectHandler) {
        clearTimeout(this.redirectHandler)
      }
    },
    startRedirectTimeout () {
      this.redirectHandler = setTimeout(this.checkRedirectTimeout, 1000)
    },
    checkRedirectTimeout () {
      if (this.redirectTime === 1) {
        this.goBackToShop()
        return
      }
      this.redirectTime--
      this.startRedirectTimeout()
    },
    sendEventButtonClickToMatomo () {
      const event = [
        MATOMO_EVENT_TYPE.trackEvent,
        MATOMO_EVENT_CATEGORY.experiments,
        'trackThankYouPageButtonBackClick'
      ]
      MatomoClass.sendEvent(event)
    },
    sendEventButtonViewToMatomo () {
      const event = [
        MATOMO_EVENT_TYPE.trackEvent,
        MATOMO_EVENT_CATEGORY.experiments,
        'trackThankYouPageButtonBackView'
      ]
      MatomoClass.sendEvent(event)
    }
  },
  mounted () {
    if (this.showTimer) {
      this.startRedirectTimeout()
    }
    const survey = document.getElementById('yourcx.insert')
    if (survey) {
      survey.addEventListener('mouseover', () => {
        this.stopRedirectTimeout()
      })
      survey.addEventListener('mouseout', () => {
        this.startRedirectTimeout()
      })
    }
    if (this.showTimer) {
      this.$refs['backButton'].addEventListener('focus', () => {
        this.stopRedirectTimeout()
      })
    }
    this.sendEventButtonViewToMatomo()
  }
}
</script>
